import { jsx as _jsx } from "react/jsx-runtime";
import { VendorsItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = (props) => _jsx(VendorsItem, { ...props });
export default Item;
